import type { SignupAvailabilityDto } from '@nomiss/sdk';
import {
  ApiRequestError,
  executeSdkRawRequest,
} from './api-request.util';
import { authenticationApi } from './sdk-client';

export type SignupAvailabilityPayload = SignupAvailabilityDto;

export type SignupAvailabilityResult = {
  phoneAvailable: boolean;
  emailAvailable: boolean;
};

export class SignupAvailabilityError extends ApiRequestError {
  constructor(status: number, message: string) {
    super(status, message, 'SignupAvailabilityError');
  }
}

export async function checkSignupAvailability(
  payload: SignupAvailabilityPayload,
): Promise<SignupAvailabilityResult> {
  return executeSdkRawRequest({
    request: () =>
      authenticationApi.authControllerCheckSignupAvailabilityV1Raw({
        signupAvailabilityDto: {
          phone: payload.phone,
          email: payload.email.trim().toLowerCase(),
        },
      }),
    fallback: 'Signup availability check failed',
    ErrorClass: SignupAvailabilityError,
  });
}
